<header>
    <div class="logo">
        <a><img src="../../../../assets/okito/images/okito-logo.svg"></a>
    </div>
    <div class="admin">
        <a><img src="../../../../assets/okito/images/pfp.png"></a>
    </div>
</header>